import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../dialog";
import { X } from "lucide-react";
import { cn } from "../../utils/cn";

interface ModalWrapperProps {
  isOpen: boolean;
  onOpenChange: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  contentStyles?: string;
  descriptionStyles?: string;
  crossStyles?: string;
}

const ModalWrapper = ({
  title,
  isOpen,
  onOpenChange,
  children,
  contentStyles,
  descriptionStyles,
  crossStyles,
}: ModalWrapperProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          "!p-0 !rounded-[20px] !overflow-hidden dark:text-black",
          contentStyles
        )}
      >
        <DialogHeader>
          <DialogTitle
            className={cn(title && "flex items-center justify-center pt-2")}
          >
            {title}
          </DialogTitle>
          <DialogDescription
            className={cn(
              "!m-0 py-10 flex flex-col items-center justify-center mx-auto",
              descriptionStyles
            )}
          >
            {children}

            <X
              className={cn(
                "absolute right-2 top-2 w-5 cursor-pointer",
                crossStyles
              )}
              onClick={onOpenChange}
            />
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(ModalWrapper);
